import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import api from "../../../../api";
import { useAuth } from "../../../Layouts/context/Authcontext";
import Analysisgraph from "../../../../components/DashboardComponents/Analysisgraph";
import BarwithsharpEdges from '../../../DashboardComponents/BarwithsharpEdges';
import AuditDetailsData from "../../../../Data/DashboardData/AMDMData/AuditDetailsData.json";
import CustomizedAuditPercentage from "../../../../components/pagecomponents/DashboardComp/AMDMComp/CustomizedAuditPercentage";
import { FaCalendarDay, FaCalendarWeek, FaCalendarAlt, FaChartLine, FaChartPie } from "react-icons/fa";
import PKT from "./PKT";
import { getRoundRobinBaseUrl } from "../../../../loadBalancer";

// components/DashboardComponents/DashboardDropDown
function AMDMQualityTab1() {
  const isDark = useSelector((state) => state.themeConfig.theme === "dark" || state.themeConfig.isDarkMode);
  const { accessToken } = useAuth();

  const [performanceData, setPerformanceData] = useState({
    yesterday: 0,
    previousWeekly: 0,
    previousMtd: 0,
    mtd: 0,
    ytd: 0,
  });

  const [balanceData, setBalanceData] = useState({
    yesterday: {},
    previousWeekly: {},
    previousMtd: {},
    mtd: {},
    ytd: {},
  });

  const [performanceDataLoading, setPerformanceDataLoading] = useState(true);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [progressWidth, setProgressWidth] = useState(0);
  const [previousWeeklyData, setPreviousWeeklyData] = useState({});
  const [currentWeeklyData, setCurrentWeeklyData] = useState({});
  const [loading, setLoading] = useState(true);
  const [selectedData, setSelectedData] = useState("previousWeekly"); // Default selection

  // Fetch Performance Data
  const fetchData = async () => {
    try {
      let baseUrls= getRoundRobinBaseUrl();
      const response = await api.get(`${baseUrls}/qaDashboard/getQAManagerAuditedPercentage`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      if (response.data.success) {
        const data = response.data.data;

        setPerformanceData({
          yesterday: data.previousDateAudited?.yesterdayPercentage || 0,
          previousWeekly: data.previousWeeklyAuditedData?.previousWeeklyPercentage || 0,
          previousMtd: data.previousMonthlyAuditedData?.previousMonthlyPercentage || 0,
          mtd: data.monthlyAuditedData?.monthlyPercentage || 0,
          ytd: data.yearlyAuditedData?.yearlyPercentage || 0,
        });

        setBalanceData({
          yesterday: {
            totalProduction: data.previousDateAudited?.totalProduction || 0,
            totalCompleted: data.previousDateAudited?.totalCompleted || 0,
            auditorTarget: data.previousDateAudited?.auditorTarget || 0,
          },
          previousWeekly: {
            totalProduction: data.previousWeeklyAuditedData?.totalProduction || 0,
            totalCompleted: data.previousWeeklyAuditedData?.totalCompleted || 0,
            auditorTarget: data.previousWeeklyAuditedData?.auditorTarget || 0,
          },
          previousMtd: {
            totalProduction: data.previousMonthlyAuditedData?.totalProduction || 0,
            totalCompleted: data.previousMonthlyAuditedData?.totalCompleted || 0,
            auditorTarget: data.previousMonthlyAuditedData?.auditorTarget || 0,
          },
          mtd: {
            totalProduction: data.monthlyAuditedData?.totalProduction || 0,
            totalCompleted: data.monthlyAuditedData?.totalCompleted || 0,
            auditorTarget: data.monthlyAuditedData?.auditorTarget || 0,
          },
          ytd: {
            totalProduction: data.yearlyAuditedData?.totalProduction || 0,
            totalCompleted: data.yearlyAuditedData?.totalCompleted || 0,
            auditorTarget: data.yearlyAuditedData?.auditorTarget || 0,
          },
        });

        setPerformanceDataLoading(false);
      } else {
        console.error("API returned an error:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching performance data:", error);
    } finally {
      setPerformanceDataLoading(false);
    }
  };


  useEffect(() => {
    fetchData();
  }, [accessToken]);


  useEffect(() => {
    const fetchQAWeeklyDifference = async () => {
      try {
        let baseUrls= getRoundRobinBaseUrl();
        const response = await api.get(
          `${baseUrls}/qaDashboard/getQAWeeklyDifference`, 
          {
            headers: { Authorization: `Bearer ${accessToken}` },
          }
        );

        if (response.data.success && response.data.data) {
          const { previousWeeklyAuditedData, currentWeeklyAuditedData } = response.data.data;

          // Extracting data for Previous and Current weeks
          const previousData = previousWeeklyAuditedData.dateWiseData || {};
          const currentData = currentWeeklyAuditedData.dateWiseData || {}

          setPreviousWeeklyData(previousData)
          setCurrentWeeklyData(currentData)


          setLoading(false);
        } else {
          console.error("QA Weekly Difference API Error:", response.data.message);
          setLoading(false);
        }
      } catch (error) {
        console.error("Error fetching QA Weekly Difference:", error);
        setLoading(false);
      }
    };

    fetchQAWeeklyDifference();
  }, [accessToken]);




  

  // Handle progress animation on hover
  const handleMouseEnter = (index) => {
    setHoveredIndex(index);
    setProgressWidth(0);
    setTimeout(() => setProgressWidth(100), 50);
  };

  const handleMouseLeave = () => {
    setHoveredIndex(null);
    setProgressWidth(0);
  };

  return (
    <>
    <h2 className="text-3xl font-extrabold text-gray-900 mb-8 text-center uppercase tracking-wide">
    Audit Performance Overview
      </h2>

  
      {/* 🔹 Dashboard Grid */}
      <div className="bg-gray-100 p-4 rounded-xl">
      <div className="grid xl:grid-cols-5 lg:grid-cols-2 sm:grid-cols-1 gap-6 mb-6">
  {[
    {
      title: "Previous Date Quality",
      key: "yesterday",
      color: "#EE1D23", // 1st card
      icon: <FaCalendarDay className="text-4xl" style={{ color: "#EE1D23" }} />,
    },
    {
      title: "Previous Week Quality %",
      key: "previousWeekly",
      color: "#1A2B5C", // 2nd card
      icon: <FaCalendarWeek className="text-4xl" style={{ color: "#1A2B5C" }} />,
    },
    {
      title: "Previous Month Quality%",
      key: "previousMtd",
      color: "#EE1D23", // 3rd card
      icon: <FaCalendarAlt className="text-4xl" style={{ color: "#EE1D23" }} />,
    },
    {
      title: "Current Month Quality%",
      key: "mtd",
      color: "#1A2B5C", // 4th card
      icon: <FaChartLine className="text-4xl" style={{ color: "#1A2B5C" }} />,
    },
    {
      title: "Yearly Audited Data %",
      key: "ytd",
      color: "#EE1D23", // 5th card
      icon: <FaChartPie className="text-4xl" style={{ color: "#EE1D23" }} />,
    },
  ].map((card, index) => (
    <div
      key={index}
      className="bg-white p-6 rounded-xl shadow-lg border-l-4 hover:shadow-xl transition-transform transform hover:scale-105 cursor-pointer relative text-center"
      style={{ borderLeftColor: card.color }}
    >
      {/* Icon */}
      <div className="flex justify-center mb-2">{card.icon}</div>

      {/* Title */}
      <h6 className="text-lg font-semibold text-gray-700 hover:text-blue-500">
        {card.title}
      </h6>

      {/* Chart */}
      <div className="mt-4">
        <Analysisgraph
          data={AuditDetailsData.AuditPlanned}
          performanceData={performanceData[card.key]}
          color={card.color}
          label="Quality Percentage"
        />
      </div>

      {/* Always visible detail box */}
      <div
        className="bg-gray-100 p-4 rounded-lg mt-4 shadow-md transition-all duration-300"
        style={{ borderLeft: `6px solid ${card.color}` }}
      >
        <h3 className="text-md font-semibold text-gray-800 mb-2">
          {card.title}
        </h3>
        <p className="text-gray-600">
          <span className="font-bold" style={{ color: card.color }}>
            🔹 Total Production:
          </span>{" "}
          {balanceData[card.key]?.totalProduction}
        </p>
        <p className="text-gray-600">
          <span className="font-bold" style={{ color: card.color }}>
            🔹 Total Completed:
          </span>{" "}
          {balanceData[card.key]?.totalCompleted}
        </p>
        <p className="text-gray-600">
          <span className="font-bold" style={{ color: card.color }}>
            🔹 Auditor Target:
          </span>{" "}
          {balanceData[card.key]?.auditorTarget}
        </p>
      </div>
    </div>
  ))}
</div>

    </div>
      {/* Dashboard Dropdown */}
      <div className="">
      {/* </div>
      <div> */}
        <CustomizedAuditPercentage/>
      </div>
      
       {/* Quality Percentage Graph */}
       <div className="xl:col-span-2 panel h-full">
          <div className="flex items-center space-x-4">
            <label className="flex items-center cursor-pointer">
              <input 
                type="radio" 
                name="weeklyData" 
                checked={selectedData === "previousWeekly"} 
                onChange={() => setSelectedData("previousWeekly")} 
              />
              <span className="text-secondary ml-2">Previous Week</span>
            </label>

            <label className="flex items-center cursor-pointer">
              <input
                type="radio" 
                name="weeklyData" 
                checked={selectedData === "currentWeekly"}  
                onChange={() => setSelectedData("currentWeekly")} 
              />
              <span className="text-secondary ml-2">Current Week</span>
            </label>
          </div>
          <BarwithsharpEdges 
              data={selectedData === "previousWeekly" ? previousWeeklyData : currentWeeklyData} 
              colors={['#00aaff', '#ffaa00']} 
              yTitle="%" 
            />
      </div>

        <div className="panel">
          <PKT/>
        </div>
    </>
  );
  
}

export default AMDMQualityTab1;
